import { DataMap } from '../../../classes';

export const updateDataMapContainer = (dataMapContainer: DataMap[], checkboxes: any[], onSiteChange: any) => {
  console.log(dataMapContainer, checkboxes)
    dataMapContainer.forEach((map, index) => {
      map.monitor.checked = checkboxes[index].checked;
      })
    onSiteChange(dataMapContainer);
  }


// WEBPACK FOOTER //
// ./src/components/Settings/utils/updateDataMapContainer.ts